import { render } from "./LandingPageList.vue?vue&type=template&id=4ec0f210"
import script from "./LandingPageList.vue?vue&type=script&lang=js"
export * from "./LandingPageList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__